<app-fn-ui-navigation-tree class="system-account-groups-navigation"
                           [treeConfig]="systemAccountGroupsService.treeConfig"
                           [treeModel]="systemAccountGroupsService.tree.nodes"
                           [selectedNode]="systemAccountGroupsService.activeNode">
</app-fn-ui-navigation-tree>
